import { useCallback, useContext, useRef, useState } from "react"
import en_img from "../../assets/eng.png"
import is_img from "../../assets/is.png"

import './index.scss'
import Icon from "../Icon"
import { useClickOutside } from "../../hooks/useClickOutside"
import { changeLanguage } from "../../services/utils/language"
import { ICON } from "../Icon/data"
import i18n from "../../i18n"
import UserContext from "../../contexts/UserContext/context"

export const LANG_OPTIONS: { [id: string]: { img?: string, label: string, locale: string }} = {
  "en": { img: en_img, locale: 'en-GB', label: i18n.t('English') },
  "is": { img: is_img, locale: 'is', label: i18n.t('Icelandic') }
}

const LangSelect = () => {
  const dropdownRef = useRef()
  const { user } = useContext(UserContext)

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [language, setLanguage] = useState<string>(user?.language ?? 'en')

  useClickOutside(dropdownRef, () => setIsOpen(false))

  const updateLanguage = useCallback((lngCode: string) => {
    changeLanguage(lngCode)
    setLanguage(lngCode)
    setIsOpen(false)
  }, [])

  return (
    <>
      <div
        className="LangSelect"
        tabIndex={0}
        role="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="LangSelect__flag">
          <img src={LANG_OPTIONS[language].img} />
        </div>
        <div className="LangSelect__chevron">
          <Icon icon={isOpen ? ICON.CHEVRON_UP : ICON.CHEVRON_DOWN} size={24} color="#161616" />
        </div>
      </div>
      {isOpen && (
        <div ref={dropdownRef} className="LangSelect__dropdown">
          {Object.keys(LANG_OPTIONS).filter(lng => lng !== language).map((lng) => {
            const { img, label } = LANG_OPTIONS[lng]
            return (
              <div
                className="LangSelect__dropdown-option"
                role="button"
                tabIndex={0}
                onClick={() => {
                  updateLanguage(lng)
                  setIsOpen(false)
                }}
              >
                <img src={img} alt={label} />
              </div>
            )
          })}
        </div>
      )}
    </>
  )
}

export default LangSelect
